module.exports = __webpack_public_path__ + "img/iconarab.dae80446.png";